import ActionTypes from './actionTypes';
import { ButtonType, ButtonVariant, ButtonColor } from '@ampol/design-system';

const defaultPrimaryButton = {
  label: 'Submit',
  color: 'blue',
  type: ButtonType.Submit,
  variant: ButtonVariant.Primary,
};

const defaultSecondaryButton = {
  label: 'Close',
  color: 'blue',
  variant: ButtonVariant.Secondary,
};

export function setAccountDefaultButton() {
  let secondaryButton = {
    ...defaultSecondaryButton,
  };

  return {
    type: ActionTypes.MODAL.SET_ALL_BUTTONS,
    payload: {
      primaryActionButton: null,
      secondaryActionButton: secondaryButton,
      tertiaryActionButton: null,
    },
  };
}

export function setAccountAddressEditButtons(options) {
  let primaryButton = {
    ...defaultPrimaryButton,
    label: 'Update',
    inactive: !!options?.inactive,
    formId: options?.formId
  };

  let secondaryButton = {
    ...defaultSecondaryButton,
    label: 'Cancel',
    onClick: options.onCancelClick
  };

  return {
    type: ActionTypes.MODAL.SET_ALL_BUTTONS,
    payload: {
      primaryActionButton: primaryButton,
      secondaryActionButton: secondaryButton,
      tertiaryActionButton: null,
    },
  };
}

export function setAccountPaymentButton(options) {
  let primaryButton = {
    ...defaultPrimaryButton, 
    label: options?.label,
    inactive: options?.inactive,
    type: options?.type,
    formId: options?.formId,
    iconSuffix: options?.iconSuffix,
    onClick: options?.onClick,
  };

  return {
    type: ActionTypes.MODAL.SET_PRIMARY_BUTTON,
    payload: primaryButton,
  };
}

export function removeAccountPaymentButton() {  
  return {
    type: ActionTypes.MODAL.SET_PRIMARY_BUTTON,
    payload: null,
  };
}


export function setAccountPaymentCloseButton(options) {
  let secondaryButton = {
    ...defaultSecondaryButton,
    formId: options?.formId,
    onClick: options?.onClick,
  };

  return {
    type: ActionTypes.MODAL.SET_SECONDARY_BUTTON,
    payload: secondaryButton,
  };
}

export function setCardDefaultButton() {
  let secondaryButton = {
    ...defaultSecondaryButton,
  };
  return {
    type: ActionTypes.MODAL.SET_ALL_BUTTONS,
    payload: {
      primaryActionButton: null,
      secondaryActionButton: secondaryButton,
      tertiaryActionButton: null,
    },
  };
}

export function setUpdatePinButtons(options) {
  let primaryButton = {
    ...defaultPrimaryButton,
    label: options?.label,
    inactive: !!options?.inactive,
    onClick: options?.onClick,
    formId: options?.formId,
  };

  let secondaryButton = {
    ...defaultSecondaryButton,
    label: 'Cancel',
    onClick: options?.onCancelClick,
  };

  return {
    type: ActionTypes.MODAL.SET_ALL_BUTTONS,
    payload: {
      primaryActionButton: primaryButton,
      secondaryActionButton: options?.onCancelClick ? secondaryButton : defaultSecondaryButton,
      tertiaryActionButton: null,
    },
  };
}

export function setResetPinButtons(options) {
  let primaryButton = {
    ...defaultPrimaryButton,
    label: options?.label,
    inactive: !!options?.inactive,
    onClick: options?.onClick,
  };

  return {
    type: ActionTypes.MODAL.SET_ALL_BUTTONS,
    payload: {
      primaryActionButton: primaryButton,
      secondaryActionButton: defaultSecondaryButton,
      tertiaryActionButton: null,
    },
  };
}

export function setUpdateCardStatusButtons(options) {
  let primaryButton = {
    ...defaultPrimaryButton,
    label: options?.label,
    inactive: !!options?.inactive,
    onClick: options?.onClick,
    formId: options?.formId,
  };

  let secondaryButton = {
    ...defaultSecondaryButton,
    label: options?.cancelLabel ? options.cancelLabel : 'Cancel',
    onClick: options?.onCancelClick,
  };

  return {
    type: ActionTypes.MODAL.SET_ALL_BUTTONS,
    payload: {
      primaryActionButton: primaryButton,
      secondaryActionButton: options?.onCancelClick ? secondaryButton : defaultSecondaryButton,
      tertiaryActionButton: null,
    },
  };
}

export function setTransferCardButtons(options) {
  let primaryButton = {
    ...defaultPrimaryButton,
    inactive: !!options?.inactive,
    formId: options?.formId,
  };

  return {
    type: ActionTypes.MODAL.SET_ALL_BUTTONS,
    payload: {
      primaryActionButton: primaryButton,
      secondaryActionButton: defaultSecondaryButton,
      tertiaryActionButton: null,
    },
  };
}

export function setCardUsageOptionsButtons(options) {
  let primaryButton = {
    ...defaultPrimaryButton,
    inactive: !!options?.inactive,
    formId: options?.formId, 
    label: 'Apply',
  };

  let secondaryButton = {
    ...defaultSecondaryButton, 
    label: 'Cancel'
  };

  return {
    type: ActionTypes.MODAL.SET_ALL_BUTTONS,
    payload: {
      primaryActionButton: primaryButton,
      secondaryActionButton: secondaryButton,
      tertiaryActionButton: null,
    },
  };
}

export function setAddEditFavouritesButtons(options) {
  let primaryButton = {
    ...defaultPrimaryButton,
    inactive: !!options?.inactive,
    formId: options?.formId, 
  };

  let secondaryButton = {
    ...defaultSecondaryButton, 
    label: 'Cancel', 
    onClick: options?.onCancelClick,
  };

  return {
    type: ActionTypes.MODAL.SET_ALL_BUTTONS,
    payload: {
      primaryActionButton: primaryButton,
      secondaryActionButton: secondaryButton,
      tertiaryActionButton: null,
    },
  };
}

export function setEditFavouritesButtons(options) {
  let primaryButton = {
    ...defaultPrimaryButton,
    label: 'Edit', 
    type: ButtonType.Button,
    onClick: options?.onClick,
  };

  let secondaryButton = {
    ...defaultSecondaryButton, 
    label: options?.onCancelClick ? 'Cancel' : 'Close', 
    onClick: options?.onCancelClick,
  };

  return {
    type: ActionTypes.MODAL.SET_ALL_BUTTONS,
    payload: {
      primaryActionButton: primaryButton,
      secondaryActionButton: secondaryButton,
      tertiaryActionButton: null,
    },
  };
}

export function setUserDetailsButton(options) {
  let primaryButton = {
    ...defaultPrimaryButton,
    label: 'Update', 
    inactive: !!options?.inactive,
    formId: options?.formId,
    type: options?.type,
  };

  let secondaryButton = {
    ...defaultSecondaryButton, 
  };

  return {
    type: ActionTypes.MODAL.SET_ALL_BUTTONS,
    payload: {
      primaryActionButton: primaryButton,
      secondaryActionButton: secondaryButton,
      tertiaryActionButton: null,
    },
  };
}

export function setDeactivateUserButtons(options) {
  let primaryButton = {
    ...defaultPrimaryButton,
    label: 'Deactivate', 
    onClick: options?.onClick,
    color: ButtonColor.Red,
  };

  let secondaryButton = {
    ...defaultSecondaryButton, 
    color: ButtonColor.Black,
  };

  return {
    type: ActionTypes.MODAL.SET_ALL_BUTTONS,
    payload: {
      primaryActionButton: primaryButton,
      secondaryActionButton: secondaryButton,
      tertiaryActionButton: null,
    },
  };
}

export function setCustomerAssignUsersButton(options) {
  let primaryButton = {
    ...defaultPrimaryButton,
    label: 'Assign', 
    onClick: options?.onClick,
    inactive: options?.inactive,
  };

  let secondaryButton = {
    ...defaultSecondaryButton, 
    ...(options?.cancelLabel ? { label: options.cancelLabel } : {}),
    ...(options?.onCancelClick ? { onClick: options.onCancelClick } : {}),
  };

  return {
    type: ActionTypes.MODAL.SET_ALL_BUTTONS,
    payload: {
      primaryActionButton: primaryButton,
      secondaryActionButton: secondaryButton,
      tertiaryActionButton: null,
    },
  };
}

export function setUserDefaultButton() {
  let secondaryButton = {
    ...defaultSecondaryButton,
  };

  return {
    type: ActionTypes.MODAL.SET_ALL_BUTTONS,
    payload: {
      primaryActionButton: null,
      secondaryActionButton: secondaryButton,
      tertiaryActionButton: null,
    },
  };
}

export function setAdminAssignUsersButton(options) {
  let primaryButton = {
    ...defaultPrimaryButton,
    label: 'Assign', 
    onClick: options?.onClick,
    inactive: options?.inactive,
  };

  let secondaryButton = {
    ...defaultSecondaryButton, 
  };

  return {
    type: ActionTypes.MODAL.SET_ALL_BUTTONS,
    payload: {
      primaryActionButton: primaryButton,
      secondaryActionButton: secondaryButton,
      tertiaryActionButton: null,
    },
  };
}

